export default __webpack_public_path__ + "static/media/user-avatar.6ce32b17.svg";